/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  OpenAPIv3EvaluationCategory,
  OpenAPIv3EvaluationCategory$inboundSchema,
} from "./openapiv3evaluationcategory.js";
import {
  OpenAPIv3EvaluationSeverity,
  OpenAPIv3EvaluationSeverity$inboundSchema,
} from "./openapiv3evaluationseverity.js";

export type OpenAPIv3EvaluationChange = {
  /**
   * A stable identifier for the kind of change.
   */
  code: string;
  /**
   * Supporting lines, such as before and after values.
   */
  details: Array<string>;
  /**
   * A one-line summary of the change.
   */
  title: string;
  /**
   * The names of the tools the change affects.
   */
  tools: Array<string>;
  /**
   * How likely the change is to break existing MCP servers.
   */
  severity: OpenAPIv3EvaluationSeverity;
  /**
   * The part of the MCP the change affects.
   */
  category: OpenAPIv3EvaluationCategory;
};

/** @internal */
export const OpenAPIv3EvaluationChange$inboundSchema: z.ZodMiniType<
  OpenAPIv3EvaluationChange,
  unknown
> = z.object({
  code: z.string(),
  details: z.array(z.string()),
  title: z.string(),
  tools: z.array(z.string()),
  severity: OpenAPIv3EvaluationSeverity$inboundSchema,
  category: OpenAPIv3EvaluationCategory$inboundSchema,
});

export function openAPIv3EvaluationChangeFromJSON(
  jsonString: string,
): SafeParseResult<OpenAPIv3EvaluationChange, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => OpenAPIv3EvaluationChange$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'OpenAPIv3EvaluationChange' from JSON`,
  );
}
